import { HIERARCHY_RULES, CONTAINER_TYPES } from '../constants';

export function buildItemTree(items) {
  const map = {};
  const roots = [];

  items.forEach((item) => {
    map[item.id] = { ...item, children: [] };
  });

  items.forEach((item) => {
    const node = map[item.id];
    if (item.parentId && map[item.parentId]) {
      map[item.parentId].children.push(node);
    } else {
      roots.push(node);
    }
  });

  const sortChildren = (nodes) => {
    nodes.sort((a, b) => (a.order || 0) - (b.order || 0));
    nodes.forEach((n) => sortChildren(n.children));
  };
  sortChildren(roots);

  return roots;
}

export function getAllowedChildTypes(parentType) {
  return HIERARCHY_RULES[parentType] || [];
}

export function isContainerType(type) {
  return CONTAINER_TYPES.includes(type);
}

export function flattenTree(nodes) {
  const result = [];
  const walk = (list) => {
    list.forEach((node) => {
      const { children, ...item } = node;
      result.push(item);
      if (children?.length) walk(children);
    });
  };
  walk(nodes);
  return result;
}

export function getAllDescendants(parentId, allItems) {
  const result = [];
  const collect = (pid) => {
    allItems.filter((i) => i.parentId === pid).forEach((child) => {
      result.push(child);
      collect(child.id);
    });
  };
  collect(parentId);
  return result;
}

export function getItemBreadcrumb(itemId, items) {
  const map = {};
  items.forEach((i) => { map[i.id] = i; });
  const chain = [];
  let current = map[itemId];
  while (current?.parentId && map[current.parentId]) {
    current = map[current.parentId];
    chain.unshift(current);
  }
  return chain;
}
